import React, { useEffect, useRef } from 'react';
import '../style/ParallaxBackground.css';
import Wave1 from '../images/background/Wave1.svg';
import Wave2 from '../images/background/Wave2.svg';
import Wave3 from '../images/background/Wave3.svg';
import Wave4 from '../images/background/Wave4.svg';
import Wave5 from '../images/background/Wave1.svg';
import Wave6 from '../images/background/Wave2.svg';
import Wave7 from '../images/background/Wave3.svg';
import Wave8 from '../images/background/Wave4.svg';

const LAYERS = [
    // White ones
    { src: Wave1, speed: 0.3 },
    { src: Wave2, speed: 0.45 },
    { src: Wave3, speed: 0.45 },
    { src: Wave4, speed: 0.3 },
];

const FULL_OPACITY_LAYERS = [
    /// Purple ones
    { src: Wave8, speed: 0.25 },
    { src: Wave7, speed: 0.50 },
    { src: Wave6, speed: 0.40 },
    { src: Wave5, speed: 0.35 },
];

    
const ParallaxBackground = () => {
    const fullOpacityLayerRefs = useRef([]);
    const layerRefs = useRef([]);

    useEffect(() => {
        let frame;
        const update = () => {
            const scrollY = window.scrollY;
            fullOpacityLayerRefs.current.forEach((el, i) => {
                if (el) el.style.transform = `translateY(${scrollY * FULL_OPACITY_LAYERS[i].speed}px)`;
            });

            layerRefs.current.forEach((el, i) => {
                if (el) el.style.transform = `translateY(${scrollY * LAYERS[i].speed}px)`;
            });
        };
        const onScroll = () => {
            cancelAnimationFrame(frame);
            frame = requestAnimationFrame(update);
        };

        update();
        window.addEventListener('scroll', onScroll, { passive: true });
        return () => {
            window.removeEventListener('scroll', onScroll);
            cancelAnimationFrame(frame);
        };
    }, []);

    return (
        <div class="parallax-background" aria-hidden="true">
            {FULL_OPACITY_LAYERS.map((layer, i) => (
                <div
                    key={layer.src}
                    ref={(el) => (fullOpacityLayerRefs.current[i] = el)}
                    class="parallax-layer full-opacity-layer"
                    style={{
                        WebkitMaskImage: `url(${layer.src})`,
                        maskImage: `url(${layer.src})`,
                    }}
                />
            ))}

            {LAYERS.map((layer, i) => (
                <div
                    key={layer.src}
                    ref={(el) => (layerRefs.current[i] = el)}
                    class="parallax-layer"
                    style={{
                        WebkitMaskImage: `url(${layer.src})`,
                        maskImage: `url(${layer.src})`,
                    }}
                />
            ))}


        </div>
    );
};

export default ParallaxBackground;
